<template>
  <h1>Buy Now</h1>
</template>
<script>
export default {
  name: "BuyNowWidget",
  data() {
    return {};
  }
};
</script>
